import styled from 'styled-components';
import { Screen } from '@CS/app/App.styles';
import { ScreenWrapper } from '@CS/app/App.styles';

export const FormWrapper = styled(ScreenWrapper)`
  padding: max(5vmax, 35px) 0;
  max-width: ${Screen.MAX};
  display: block;
`;

export const ContentWrapper = styled.div`
  padding-right: max(6.667vmin, 25px);
  padding-left: max(6.667vmin, 25px);

  position: relative;
  display: block;
  z-index: 1;
`;
